/**
 * 작업 관리 관련 API
 * - 작업 상태 조회: GET /conversion-job/{job_id} 사용 (Bearer 토큰 필요)

* - 사용 중단: GET /api/jobs/await-assetbundle/{id}, GET /unity/job/{id}/status
 */

import { apiCall } from "./base";

/**
 * 작업 상태 조회 (변환 작업 등)
 * GET /conversion-job/{job_id} 사용.
 */
export const getJobStatus = async (
  jobId: string,
  userToken: string | null
): Promise<unknown> => {
  const options: RequestInit = {
    method: "GET",
    headers: {
      Authorization: userToken ? `Bearer ${userToken}` : "",
    },
  };
  return await apiCall(`/conversion-job/${jobId}`, options);
};

/**
 * Unity API 서버 상태 확인
 */
export const getUnityStatus = async (
  userToken: string | null
): Promise<unknown> => {
  const options: RequestInit = {
    method: "GET",
    headers: {
      Authorization: userToken ? `Bearer ${userToken}` : "",
    },
  };
  return await apiCall("/unity/status", options);
};

/** POST /api/jobs/{job_id}/cancel 응답 */
export interface CancelJobResponse {
  status: string;
  message: string;
  job_id: string;
}

/**
 * 변환/ViewR 작업 취소 (POST /api/jobs/{job_id}/cancel)
 * 이미 completed/failed인 경우 409 반환
 */
export const cancelJob = async (
  jobId: string,
  userToken: string | null
): Promise<CancelJobResponse> => {
  const options: RequestInit = {
    method: "POST",
    headers: {
      Authorization: userToken ? `Bearer ${userToken}` : "",
      "Content-Type": "application/json",
    },
  };
  return (await apiCall(
    `/api/jobs/${encodeURIComponent(jobId)}/cancel`,
    options
  )) as CancelJobResponse;
};

/** 변환 일시정지: 백엔드에서 Docker 종료 후 job=paused */
export const pauseConversionJob = async (
  jobId: string,
  userToken: string | null
): Promise<{ job_id: string; status: string }> => {
  const options: RequestInit = {
    method: "POST",
    headers: {
      Authorization: userToken ? `Bearer ${userToken}` : "",
      "Content-Type": "application/json",
    },
  };
  return (await apiCall(
    `/api/jobs/${encodeURIComponent(jobId)}/pause-conversion`,
    options
  )) as { job_id: string; status: string };
};

/** 일시정지한 변환 재시작 (동일 job_id) */
export const resumeConversionJob = async (
  jobId: string,
  userToken: string | null
): Promise<{ job_id: string; status: string }> => {
  const options: RequestInit = {
    method: "POST",
    headers: {
      Authorization: userToken ? `Bearer ${userToken}` : "",
      "Content-Type": "application/json",
    },
  };
  return (await apiCall(
    `/api/jobs/${encodeURIComponent(jobId)}/resume-conversion`,
    options
  )) as { job_id: string; status: string };
};

